/**
 * Fetch a source code from a cookie
 *
 * @return {bool|string}
 *   The sourcecode or false if it does not exist
 */
const fetchSourceCodeFromCookie = () => {
  const sourcecode = Cookies.get("sourcecode");

  if (sourcecode !== null) {
    return sourcecode;
  }

  return false;
};

export default fetchSourceCodeFromCookie;
